import React, { Component } from "react";
import { connect } from "react-redux";
import Countdown from "react-countdown";
import NumberFormat from "react-number-format";
import {
  selectMemberInfo,
  saveContactInfos,
  reSendValidateCodeContactInfos,
  clearContactInfoRedirect,
} from "../../../state/ducks/member/index";
import $ from "jquery";

class UpdateContactInfo extends Component {
  state = {
    bilgi: this.props.member?.bilgi,
    iletisimTur: this.props.match?.params?.id,
    kod: "",
  };
  componentDidMount() {
    this.props.clearRedirect();
  }

  timerEnd() {
    $("#kod").prop("disabled", true);
    $("#submit").prop("disabled", true);
    $("#tekrar_gonder").prop("disabled", false);
    $("#submit").css("pointer-events", "none");
    $("#tekrar_gonder").css("pointer-events", "all");
  }

  timerStart() {
    var time = this.props.member?.countDate + 180000 < Date.now();
    $("#kod").prop("disabled", time);
    $("#submit").prop("disabled", time);
    if (time) {
      $("#tekrar_gonder").prop("disabled", false);
      $("#tekrar_gonder").css("pointer-events", "all");
    } else {
      $("#tekrar_gonder").prop("disabled", true);
      $("#submit").css("pointer-events", "all");
      $("#tekrar_gonder").css("pointer-events", "none");
    }
    if (this.props.member?.saveContact) {
      $("#tekrar_gonder").prop("disabled", true);
      $("#tekrar_gonder").css("pointer-events", "none");
    }
  }

  resetCounter() {
    this.props.reSendValidateCode(this.state.bilgi, this.state.iletisimTur);
  }

  submit = (event) => {
    event.preventDefault();
    this.props.saveContactInfo(
      this.state.bilgi,
      this.state.iletisimTur,
      this.state.kod
    );
  };

  render() {
    const { match, member } = this.props;
    return (
      <div className="container-fluid">
        {/* Yeşil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backtop"
                style={{
                  backgroundImage:
                  'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div className="col-12 d-flex justify-content-center pb-2">
                    <i className="t-icon-lock_clock t-icGenelBaslikIcon" />
                  </div>
                  <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslik">
                    DOĞRULAMA
                  </div>
                  <div className="col-12 text-center t-icYazilar">
                    <p hidden={match?.params?.id !== "Eposta"}>
                      Lütfen{" "}
                      {member?.bilgi?.split("@")[0].substring(0, 3) +
                        "**********@" +
                        member?.bilgi?.split("@")[1]}{" "}
                      adresine gönderilen kodunu giriniz.
                    </p>
                    <p hidden={match?.params?.id !== "Gsm"}>
                      Lütfen{" "}
                      {member?.bilgi?.substring(0, 3) +
                        "******" +
                        member?.bilgi?.substring(member?.bilgi?.length - 2, member?.bilgi?.length)}{" "}
                      nolu cep telefonunuza gönderilen kodunu giriniz.
                    </p>
                  </div>
                </div>
                {/* Kod */}
                <div className="row no-gutters my-4 d-flex justify-content-center flex-column align-items-center">
                  <div className="col-auto pb-1">
                    <span className="t-icInputTitle pl-3 text-center">Doğrulama Kodu</span>
                  </div>
                  <div className="col-auto pb-4">
                    <div className="t-icInput" style={{ maxWidth: 350 }}>
                      <div>
                        <i className="t-icon-phonelink_lock" />
                      </div>
                      <NumberFormat
                        id="kod"
                        name="kod"
                        type="text"
                        displayType={"input"}
                        format="######"
                        placeholder="Kod"
                        value={this.state.kod}
                        autoComplete="false"
                        onChange={(e) => {
                          this.setState({ kod: e.target.value });
                        }}
                      />
                      <div />
                    </div>
                  </div>
                  <div
                    className="col-auto"
                    style={{ color: "#0c9908", fontWeight: "bold" }}
                  >
                    <i className="t-icon-clock pr-2" />
                    Kalan süre
                    <strong id="saniye" style={{ fontSize: "16pt" }}>
                      <Countdown
                        key={member?.countDate}
                        date={member?.countDate + 180000}
                        renderer={(props) => (
                          <strong id="count_down">
                            {" "}
                            {props.total / 1000} 
                          </strong>
                        )}
                        onStart={() => this.timerStart()}
                        onComplete={() => this.timerEnd()}
                      ></Countdown>
                    </strong>
                   {" "} sn
                  </div>
                </div>
                {/* Değiştir*/}
                <div className="row no-gutters d-flex align-items-center justify-content-center">
                  <div className="col-auto px-1">
                    <button
                      type="button"
                      className="t-icButonTrunucu"
                      id="tekrar_gonder"
                      name="tekrar_gonder"
                      onClick={() => this.resetCounter()}
                    >
                      <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                      <span />
                      <span className="pb-1">Tekrar Gönder</span>
                    </button>
                  </div>
                  <div className="col-auto px-1">
                    <button
                      className="t-icButtonYesil"
                      id="submit"
                      name="submit"
                      type="submit"
                      onClick={this.submit}
                    >
                      <span />
                      <span className="pb-1">Doğrula</span>
                      <i
                        className="t-icon-arrow-right2"
                        style={{ fontSize: "14pt" }}
                      />
                    </button>
                  </div>
                </div>
                {/* STEP LER */}
                <div className="row no-gutters pt-4 justify-content-center align-items-start">
                  {/* cizgi*/}
                  <div className="col-1 t-cizgiBackgroundKenar" />
                  {/* 1*/}
                  <div className="col-auto t-icStepPasif">
                    <div className="ortala">
                      <div className="yuvarlak">1</div>
                    </div>
                    <span hidden={match?.params?.id !== "Eposta"} style={{fontSize:"small"}}> Yeni Mail</span>
                    <span hidden={match?.params?.id !== "Gsm"} style={{fontSize:"small"}}> Yeni Tel</span>
                  </div>
                  {/* cizgi*/}
                  <div className="col-auto t-cizgiBackgroundOrta" />
                  {/* 2*/}
                  <div className="col-auto t-icStepAktif">
                    <div className="ortala">
                      <div className="yuvarlak">2</div>
                    </div>
                    <span>Onay</span>
                  </div>
                  {/* cizgi*/}
                  <div className="col-1 t-cizgiBackgroundKenar" />
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearRedirect: () => dispatch(clearContactInfoRedirect()),
  saveContactInfo: (bilgi, iletisimTur, smsKod) =>
    dispatch(saveContactInfos(bilgi, iletisimTur, smsKod)),
  reSendValidateCode: (bilgi, iletisimTur) =>
    dispatch(reSendValidateCodeContactInfos(bilgi, iletisimTur)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateContactInfo);
